export default __webpack_public_path__ + "static/media/746.92a30f87.gif";